import { Icon, IconProps, useColorModeValue } from '@chakra-ui/react'

export function CompassMiningIcon(props: IconProps) {
  const isDark = useColorModeValue(false, true)

  if (isDark) {
    return (
      <Icon viewBox="0 0 18 16" fill="none" {...props}>
        <g clipPath="url(#clip0_dark)">
          <path
            d="M12.0741 13.3163C12.0867 13.2931 12.0712 13.2658 12.0461 13.2658C10.1881 13.2658 7.55672 13.2678 5.71225 13.2678V13.2577L2.80634 8.04399C2.80054 8.03286 2.80054 8.01972 2.80634 8.00961L5.76155 2.60178C5.76735 2.59066 5.77799 2.58459 5.79055 2.58459L11.5656 2.5583C11.5772 2.5583 11.5869 2.55223 11.5927 2.54212C11.9339 1.9162 12.5981 0.69873 12.9509 0.0515705C12.9635 0.0283132 12.9471 0 12.9219 0L4.3869 0.0384251C4.3753 0.0384251 4.3637 0.0455034 4.3579 0.0556152L0.00483844 8.02275C-0.000961773 8.03286 -0.000961773 8.045 0.00483844 8.05511C0.718265 9.33527 3.77305 14.8149 4.4246 15.9838C4.4304 15.9939 4.44007 16 4.45167 16C6.18013 15.9919 8.87627 15.9798 10.6076 15.9727C10.6192 15.9727 10.6289 15.9666 10.6347 15.9565C11.0156 15.2578 11.6845 14.0312 12.0741 13.3173V13.3163Z"
            fill="white"
          />
          <path
            d="M13.2663 9.89343L12.7993 9.14717L15.4839 4.12562L15.5699 3.96484L14.4331 1.97483L8.82522 12.0361H7.96196L13.9004 1.12644L13.5495 0.485352L6.91309 12.6732H9.17517L14.4398 3.22668L14.8671 3.97496L12.0559 9.2675L13.244 11.2747L16.0504 6.16215L16.4747 6.85785L11.5359 15.911L13.7602 15.9818L18.0002 8.21081L17.6464 7.57377L13.4122 15.3336L12.5664 15.3073L17.1853 6.83863L15.9653 4.84154L13.2663 9.89343Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_dark">
            <rect width="18" height="16" fill="white" />
          </clipPath>
        </defs>
      </Icon>
    )
  }

  return (
    <Icon viewBox="0 0 13 11" fill="none" {...props}>
      <g clipPath="url(#clip0_light)">
        <path
          d="M8.2213 8.86425C8.22986 8.84876 8.21933 8.83059 8.20221 8.83059C6.93704 8.83059 5.14527 8.83194 3.88931 8.83194V8.8252L1.91059 5.35463C1.90664 5.34722 1.90664 5.33847 1.91059 5.33174L3.92288 1.73192C3.92683 1.72452 3.93407 1.72048 3.94263 1.72048L7.87506 1.70298C7.88296 1.70298 7.88954 1.69894 7.89349 1.69221C8.12586 1.27555 8.57808 0.465122 8.81834 0.0343288C8.8269 0.0188472 8.81571 0 8.79859 0L2.98684 0.0255784C2.97894 0.0255784 2.97104 0.0302902 2.96709 0.0370213L0.00296216 5.34049C-0.000987386 5.34722 -0.000987386 5.3553 0.00296216 5.36203C0.488756 6.21419 2.56885 9.8618 3.01251 10.6399C3.01646 10.6467 3.02305 10.6507 3.03095 10.6507C4.20791 10.6453 6.04379 10.6372 7.22273 10.6325C7.23063 10.6325 7.23721 10.6285 7.24116 10.6217C7.50051 10.1566 7.95603 9.34014 8.2213 8.86492V8.86425Z"
          fill="url(#paint0_light)"
        />
        <path
          d="M9.0331 6.5859L8.71516 6.08914L10.5431 2.74645L10.6017 2.63943L9.82761 1.31474L6.00906 8.01223H5.42124L9.46491 0.749997L9.22597 0.323242L4.70703 8.43629H6.24735L9.83222 2.14806L10.1232 2.64616L8.20896 6.16924L9.01796 7.50537L10.9289 4.10211L11.2179 4.56521L7.85482 10.5916L9.36947 10.6387L12.2566 5.46584L12.0157 5.04177L9.13249 10.2073L8.55652 10.1898L11.7017 4.55242L10.871 3.22302L9.0331 6.5859Z"
          fill="url(#paint1_light)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_light"
          x1="4.32889"
          y1="1.48793"
          x2="10.3021"
          y2="12.0005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0060FF" />
          <stop offset="1" stopColor="#00FFBD" />
        </linearGradient>
        <linearGradient
          id="paint1_light"
          x1="4.04046"
          y1="1.78327"
          x2="10.898"
          y2="12.7152"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0060FF" />
          <stop offset="1" stopColor="#00FFBD" />
        </linearGradient>
        <clipPath id="clip0_light">
          <rect width="12.2567" height="10.6507" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  )
}
